import { createContext, useContext } from "react";

const TickerContext = createContext({ now: 0 });

export const TickerContextProvider = TickerContext.Provider;

export const useTickerContext = () => useContext(TickerContext);

export default TickerContext;
